<form [formGroup]="form" class="style-form-default">
  <div
    class="style-input-default marginTop"
    data-text="Tipo persona *"
    [ngClass]="{ error: verificateInput('tipo_persona') }"
  >
    <input
      type="text"
      placeholder="Tipo persona"
      formControlName="tipo_persona"
    />
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Nombre de la empresa *"
    [ngClass]="{ error: verificateInput('nombre_empresa') }"
  >
    <input
      type="text"
      placeholder="Nombre de la empresa"
      formControlName="nombre_empresa"
    />
  </div>
  <div
    class="style-input-default marginTop"
    data-text="RIF de la empresa *"
    [ngClass]="{ error: verificateInput('rif') }"
  >
    <input type="text" placeholder="J123456789" ciRif formControlName="rif" />
    <mat-error *ngIf="form.get('rif').hasError('pattern')"
      >El rif es <strong>inválido</strong></mat-error
    >
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Razón social *"
    [ngClass]="{ error: verificateInput('razon_social') }"
  >
    <input
      type="text"
      placeholder="Razón social"
      formControlName="razon_social"
    />
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Cédula *"
    [ngClass]="{ error: verificateInput('cedula') }"
  >
    <input type="text" placeholder="Cédula" ciRif formControlName="cedula" />
    <mat-error *ngIf="form.get('cedula').hasError('pattern')"
      >La Cédula es <strong>inválida</strong></mat-error
    >
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Nombres y apellidos *"
    [ngClass]="{ error: verificateInput('nombre') }"
  >
    <input
      type="text"
      placeholder="Nombres y apellidos"
      formControlName="nombre"
    />
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Télefonos *"
    [ngClass]="{ error: verificateInput('telefono') }"
  >
    <input type="text" placeholder="Télefonos" numberPhone formControlName="telefono" />
    <mat-error *ngIf="form.get('telefono').hasError('pattern')"
      >El telefono es <strong>inválido</strong></mat-error
    >
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Dirección *"
    [ngClass]="{ error: verificateInput('direccion') }"
  >
    <input type="text" placeholder="Dirección" formControlName="direccion" />
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Dirección laboral *"
    [ngClass]="{ error: verificateInput('direccion_laboral') }"
  >
    <input
      type="text"
      placeholder="Dirección laboral"
      formControlName="direccion_laboral"
    />
  </div>
  <div
    class="style-input-default marginTop column-complete"
    data-text="Otras direcciones en BDV *"
    [ngClass]="{ error: verificateInput('otras_direcciones_BDV') }"
  >
    <input
      type="text"
      placeholder="Otras direcciones en BDV"
      formControlName="otras_direcciones_BDV"
    />
  </div>
  <div
    class="style-input-default marginTop column-complete"
    data-text="Cuentas BDV *"
    [ngClass]="{ error: verificateInput('cuentas_BDV') }"
  >
    <input
      type="text"
      placeholder="Cuentas BDV"
      onlyNumber
      formControlName="cuentas_BDV"
    />
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Oficina tutora *"
    [ngClass]="{ error: verificateInput('oficina_tutora') }"
  >
    <input
      type="text"
      placeholder="Oficina tutora"
      formControlName="oficina_tutora"
    />
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Saldo *"
    [ngClass]="{ error: verificateInput('saldo') }"
  >
    <input type="text" Currency placeholder="Saldo" formControlName="saldo" />
    <mat-error *ngIf="form.get('saldo').hasError('pattern')"
      >El saldo es <strong>inválido</strong></mat-error
    >
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Correo *"
    [ngClass]="{ error: verificateInput('correo') }"
  >
    <input type="text" placeholder="Correo" formControlName="correo" />
    <mat-error *ngIf="form.get('correo').hasError('email')"
      >El Correo es <strong>inválido</strong></mat-error
    >
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Referencia personal BDV *"
    [ngClass]="{ error: verificateInput('referencia_personal_BDV') }"
  >
    <input
      type="text"
      placeholder="Referencia personal BDV"
      formControlName="referencia_personal_BDV"
    />
  </div>
</form>
